import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=4400e4d8"
import script from "@/views/modules/Reminders/js/DetailView.js?vue&type=script&lang=js&external"
export * from "@/views/modules/Reminders/js/DetailView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports